import { Button } from "@mui/material";
import useReporting from "hooks/useReporting";
import FileDownload from "@mui/icons-material/FileDownload";
import { Pickup } from "types/pickup";
import { downloadFile } from "utils/files";

type PricingProps = {
  pickup: Pickup;
};

export default function PricingToolBarButton({ pickup }: PricingProps) {
  const { getPricingReportData, pricingReportData, loadingPricing, downloadPricingFile, setDownloadPricingFile } =
    useReporting();

  if (downloadPricingFile) {
    setDownloadPricingFile(false);
    downloadFile(pricingReportData, `pickup_${pickup.id}_pricing_data.csv`);
  }

  return (
    <Button
      variant="outlined"
      startIcon={<FileDownload />}
      size="large"
      disabled={loadingPricing ? true : false}
      onClick={() => {
        getPricingReportData(pickup.uuid);
      }}
    >
      Pricing
    </Button>
  );
}
